// src/components/stripe/StripeWrapper.js
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

export const StripeWrapper = ({ children }) => (
  <Elements stripe={stripePromise}>
    {children}
  </Elements>
);